/* @flow */
import Group from 'entities/Group';
import Groups from 'collections/Groups';
import OfficeHours from 'entities/OfficeHours';
import OfficeHoursDay from 'entities/OfficeHoursDay';
import { ActionTypes as ChatSettingsActionTypes } from 'settings/constants/ChatSettingsConstants';
import { ActionTypes as GroupActionTypes } from 'groups/constants/GroupConstants';
import { dispatcher } from 'lib/Dispatcher';

const ChatSettingsActions = {
  loadOfficeHours() {
    return OfficeHours.yieldForCurrentUser().then(hours => {
      dispatcher.dispatch({
        type: ChatSettingsActionTypes.OFFICE_HOURS_LOADED,
        hours,
      });
    });
  },

  enableOfficeHours() {
    const hours = new OfficeHours();

    dispatcher.dispatch({
      type: ChatSettingsActionTypes.OFFICE_HOURS_ENABLED,
      hours,
    });

    return ChatSettingsActions.setOfficeHours(hours.getAvailability());
  },

  disableOfficeHours() {
    const hours = new OfficeHours({
      available: [],
    });

    dispatcher.dispatch({
      type: ChatSettingsActionTypes.OFFICE_HOURS_DISABLED,
      hours,
    });

    return ChatSettingsActions.setOfficeHours(hours.getAvailability());
  },

  setOfficeHours(available: OfficeHoursDay[]) {
    const hours = new OfficeHours({
      available,
    });

    dispatcher.dispatch({
      type: ChatSettingsActionTypes.OFFICE_HOURS_UPDATED,
      hours,
    });

    return OfficeHours.setForCurrentUser(available);
  },

  updateAllowGroupsToStartChat(groups: { [id: string]: Group }) {
    for (const id in groups) {
      dispatcher.dispatch({
        type: GroupActionTypes.CAN_START_CHAT_CHANGED,
        groupId: id,
        canStartChat: groups[id],
      });
    }

    // $FlowFixMe - ignoring group weirdness.
    return Groups.setGroupsAllowedToStartChat(groups).then(updatedGroups => {
      dispatcher.dispatch({
        type: GroupActionTypes.GROUPS_UPDATED,
        groups: updatedGroups,
      });
    });
  },
};

export default ChatSettingsActions;
